import { render, staticRenderFns } from "./GroupsUsers.vue?vue&type=template&id=0e78451e"
import script from "./GroupsUsers.vue?vue&type=script&lang=js"
export * from "./GroupsUsers.vue?vue&type=script&lang=js"
import style0 from "./GroupsUsers.vue?vue&type=style&index=0&id=0e78451e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports